import React, { Component } from 'react';
import axios from 'axios';
import { FaRegStar, FaStar } from "react-icons/fa";

class TutorAddReview extends Component {
  state = {
    full_name: "",
    email: "",
    rating: 0,
    comment: "",
    image: null,
    windowHeight: window.innerHeight - 60,
    loading: false,
  };

  fileInputRef = React.createRef();

  handleInputChange = (event) => {
    const { name, value, files } = event.target;
    if (name === "image") {
      this.setState({ image: files[0] });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleStarClick = (selectedRating) => {
    this.setState({ rating: selectedRating });
  };

  renderStarButtons = () => {
    return [...Array(5)].map((_, i) => {
      const starNumber = i + 1;
      return (
        <button
          key={`star-${starNumber}`}
          type="button"
          className="star-button"
          onClick={() => this.handleStarClick(starNumber)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.2em',
            color: 'rgb(195, 125, 22)',
            marginRight: '5px',
          }}
        >
          {this.state.rating >= starNumber ? <FaStar /> : <FaRegStar />}
        </button>
      );
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    const { full_name, email, rating, comment, image } = this.state;
    const course_id = parseInt(this.props.course_id, 10);

    const formData = new FormData();
    formData.append("course", course_id);
    formData.append("full_name", full_name);
    formData.append("email", email);
    formData.append("rating", rating);
    formData.append("comment", comment);
    if (image) {
      formData.append("pic_or_video", image);
    }

    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await axios.post(
        `https://api.geoinfoacademy.com/api/tutor/reviews/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log("Review submitted:", response.data);
      alert("Review submitted successfully!");

      this.setState({
        full_name: "",
        email: "",
        rating: 0,
        comment: "",
        image: null,
      });

      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = null;
      }

      // HIDE the form after submission
      const formDisplay = document.querySelector(".dash_add_course_cover.addreview");
      if (formDisplay) {
        formDisplay.style.display = "none";
      }

      if (this.props.onRefresh) {
        this.props.onRefresh();
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      alert("Failed to submit review.");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight - 60 });
  };

  // ✅ Clicking outside the form closes it
  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      const formDisplay = document.querySelector(".dash_add_course_cover.addreview");
      if (formDisplay) {
        formDisplay.style.display = "none";
      }
    }
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  render() {
    const { windowHeight, loading } = this.state;

    return (
      <div className="dash_add_course_cover addreview" style={{ height: windowHeight }}>
        <div className="dash_form_container" ref={(node) => (this.node = node)}>
          <h2>Submit Tutor Review</h2>
          <form onSubmit={this.handleSubmit} className='add_course_form'>
            <label>Full Name</label>
            <input
              type="text"
              name="full_name"
              value={this.state.full_name}
              onChange={this.handleInputChange}
              placeholder="Jane Tutor"
              required
            />

            <label>Email</label>
            <input
              type="email"
              name="email"
              value={this.state.email}
              onChange={this.handleInputChange}
              placeholder="jane.tutor@example.com"
              required
            />

            <label>Upload Picture/Video</label>
            <input
              type="file"
              name="image"
              ref={this.fileInputRef}
              onChange={this.handleInputChange}
              accept="image/*,video/*"
            />

            <label>Rating</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {this.renderStarButtons()}
            </div>

            <label>Comment</label>
            <textarea
              name="comment"
              value={this.state.comment}
              onChange={this.handleInputChange}
              placeholder="Write your review here..."
              required
            />

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Review"}
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default TutorAddReview;
